import React from "react";
import { useFluidForm } from "../FormContext";
import { FluidFormFields } from "../FormFields.component";
import { useRenderViewChange } from "../common";
import { Button } from "semantic-ui-react";
import { SimpleFormClearButton } from "../SimpleFormClearButton";
export const ClassicForm = ({ onSubmit, fieldProps }) => {
    let configService = useFluidForm();
    const submitButtonLabel = configService.getAdditionalConfigValue("styleConfig", "submitButtonLabel") || "Submit";
    useRenderViewChange("classic");
    return React.createElement(React.Fragment, null,
        React.createElement(FluidFormFields, { field: configService.getRenderView(), options: fieldProps }),
        onSubmit && (React.createElement("div", { style: { marginTop: '1.5em', display: 'flex', alignItems: 'center', gap: '0.5rem' } },
            React.createElement(SimpleFormClearButton, null),
            React.createElement(Button, { primary: true, className: "fluid-button-primary", onClick: onSubmit }, submitButtonLabel))));
};
function ClassicFormFields() {
    return React.createElement(React.Fragment, null,
        React.createElement(FluidForm, { config: {
                token: "xxx-xxx-xxx-xxx", //You get this from the Fluid-Form Dashboard
                formId: "w9-form", //This is the FormId of the form that you created in the FormAgent Builder
                modes: {
                    'slack': true,
                    'getStream': true,
                    'classic': true,
                },
                styles: {
                    primaryColor: "#2563eb",
                    secondaryColor: "#60a5fa",
                    input: {
                        borderRadius: "10px",
                    }
                }
            }, initialContext: () => ({
            /*
              - Here you can pass initial context to the Form Agent to help the user filling the form,
              For example existing user information that is only accessible by your platform.
            - This can also be done directly in the backend in the case of sensitive information.*/
            }), onFieldChange: (field, value) => {
                /* Here you can handle the field change event when the user fills one or more fields at once.
                  I.E if the user uploads a file affecting multiple fields.*/
            }, onSubmit: (data) => {
                // Here you can handle the validated and structured form data when the user submits the form. 
            } }));
}
function FluidForm({ config, onSubmit, onFieldChange }) {
    return React.createElement("div", null,
        React.createElement("h1", null, "Fluid Form"));
}
